import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import submitSuccessFul from "../../assets/images/submit-successful.png";
import { useTranslation } from "react-i18next";
import useGetToken from "../../store/selectors/get-token";

const ReminderPage = () => {
	const [image, setImage] = useState(submitSuccessFul);
	const [data, setData] = useState({});

	const { t } = useTranslation();

    const token = useGetToken();
    const navigate = useNavigate();

	useEffect(() => {
		// Set details for display
        const reminderData = localStorage.getItem("reminderData");
        if (reminderData) {
            setData(JSON.parse(reminderData));
        }
	}, []);

	function formatDate(dateStr) {
		if (!dateStr) return "";
		const date = new Date(dateStr);

		if (isNaN(date)) return ""; // handle invalid date

		const day = String(date.getDate()).padStart(2, "0");

		const months = [
			"JAN",
			"FEB",
			"MAR",
			"APR",
			"MAY",
			"JUN",
			"JUL",
			"AUG",
			"SEP",
			"OCT",
			"NOV",
			"DEC",
		];

		const month = months[date.getMonth()];
		const year = date.getFullYear();

		return `${day}-${month}-${year}`;
	}

    const handleExploreOther = (e) => {
        e.preventDefault();
        navigate(`/get-quotes?token=${token}`, {
            replace: true
        });
    };

    const handleBackButton = (e) => {
        e.preventDefault();
        window.ReactNativeWebView.postMessage('closeWebView');
    };

	return (
		<div className="content">
			<div
				className="get-quote-process-container justify-content-between"
				style={{ flexDirection: "row", alignContent: "space-between" }}
			>
				<div className="get-quote-container d-m-column p-0">
					<div className="filters d-flex flex-column justify-content-center align-items-center w-100 mt-6">
						<Image className="mr-2" src={image} height={80} width={80} />
						<h3>Reminder Set!</h3>
						<span className="formatted-text text-center">{`You'll receive a reminder notification before your renewal date.`}</span>
					</div>
					<div className="car-details-block border-radius-25 m-0 px-2 w-100">
						<div
							className="select-variant-container mb-2 p-0 pt-2"
							style={{ maxHeight: "100vh", overflow: "auto" }}
						>
							<div className="owner-info">
								<div className="card text-left">
									<h5 className="owner-info-title m-0 fw-medium">
										{`Your Vehicle Details`}
									</h5>
									<div className="owner-info-row p-0">
										<span
											style={{
												flex: "inherit",
												fontSize: "14px",
												lineHeight: "18px",
											}}
										>
											{t(`common.vehicleRegistrationNo`)}
										</span>
										<strong style={{ fontSize: "14px", lineHeight: "18px" }}>
											{data.reg_no}
										</strong>
									</div>
									<div className="owner-info-row p-0">
										<span
											style={{
												flex: "inherit",
												fontSize: "14px",
												lineHeight: "18px",
											}}
										>
											{`Your Next Effective NCD`}
										</span>
										<strong
											style={{ fontSize: "14px", lineHeight: "18px" }}
										>{`${parseFloat(data.ncd_percent)}%`}</strong>
									</div>
									<div className="owner-info-row p-0">
										<span
											style={{
												flex: "inherit",
												fontSize: "14px",
												lineHeight: "18px",
											}}
										>
											{`Current Policy's Expiry Date`}
										</span>
										<strong
											style={{ fontSize: "14px", lineHeight: "18px" }}
										>{`${formatDate(data.currPolExpiryDate)}`}</strong>
									</div>
									<div className="owner-info-row p-0">
										<span
											style={{
												flex: "inherit",
												fontSize: "14px",
												lineHeight: "18px",
											}}
										>
											{`Earliest Date to Renew`}
										</span>
										<strong
											style={{ fontSize: "14px", lineHeight: "18px" }}
										>{`${formatDate(data.earliestRenewDate)}`}</strong>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="d-flex w-100">
					<Button
						className="btn-primary fw-bold"
						label={`Explore Other Vehicles`}
						onClick={(e) => handleExploreOther(e)}
					/>
					<Button
						className="btn-secondary fw-bold"
						label={`Back to Home`}
						onClick={(e) => handleBackButton(e)}
					/>
				</div>
			</div>
		</div>
	);
};

export default ReminderPage;
